import {Component, Vue, Watch} from 'vue-property-decorator'
import {menuBtn} from "@/utils/menu_level2_button";
import {gettHeaderByType, settHeaderByType} from "@/api/common";
import {delNullProperty} from "@/utils";
import {delClasses, exportClassesData, getClasses} from "@/api/classManage";
import {formatDate} from "@/utils/timeFilter";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

@Component({
    components: {MoreUsersFilter}
})
export default class ClassMange extends Vue {
    // ------ 变量 ------
    buttonShow = menuBtn // 方法：按钮权限验证
    tableData = []
    checkTableList = []
    page = 1
    pageSize = 20
    total = 0
    loading = false
    classTableHead: any[] = [] // 表头顺序列表
    draggableListChange = []
    draggableList = []
    tableHeadPopoverShow = false // 调整表头顺序的弹框是否可见
    vdaH = 0 //屏幕高度
    popHeight = 0
    timer = null
    exportButtonDisabled = false
    filterList = {
        name: '',
        souCourseTypeId: '',
        souCourseName: '',
        souCourseSchoolBegin: '',
        classesCode: '',
        thesisUserId: '',
        teacherUserId: '',
        helperUserId: '',
        souTeacherName:'', // 导师
        applyUserId:'', // 网申负责人
    }
    createdAt: Date[] | null = null // 开课时间
    typeList = commonData.projectTypeArray
    delClassDialogShow = false
    delId = ''
    thesisUserId = ''
    teacherUserId = ''
    helperUserId = ''
    applyUserId = ''
    filter_price  = '' //订单金额
    filter_amount = '' //订单金额

    created() {
        this.getClassClueHeader()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260;
        this.popHeight = this.vdaH
    }

    // get userListNew() {
    //     return UserModule.userList
    // }
    @Watch('arrfilter_price')
    handlearrfilter_price(nVal, oVal) {
        if ((nVal.filter_price && nVal.filter_amount)|| (!nVal.filter_price && !nVal.filter_amount)) {
            this.pageChange(1)
        }
    }
    get arrfilter_price() {
        const filter_price = this.filter_price
        const filter_amount = this.filter_amount
        return {
            filter_price, filter_amount
        }
    }

    // 获取表头
    async getClassClueHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(22)
        this.draggableList = data.headerUserList
        this.classTableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    async getTableData() {
        if(this.filter_price && ! /^[0-9]+$/.test(this.filter_price)) {
            this.$message.error('班级人数只能输入正整数！')
            return
        }
        this.loading = true
        this.checkTableList = []

        const teacherUserId = this.teacherUserId == 'null' ? this.teacherUserId : this.filterList.teacherUserId
        const thesisUserId = this.thesisUserId == 'null' ? this.thesisUserId : this.filterList.thesisUserId
        const helperUserId = this.helperUserId == 'null' ? this.helperUserId : this.filterList.helperUserId
        const applyUserId = this.applyUserId == 'null' ? this.applyUserId : this.filterList.applyUserId
        const financeOrderCount = this.filter_amount && this.filter_price ? this.filter_amount + this.filter_price: null
        const obj = {
            name: this.filterList.name,
            code: this.filterList.classesCode,
            teacherUserId: teacherUserId,
            thesisUserId: thesisUserId,
            helperUserId: helperUserId,
            applyUserId: applyUserId,
            souCourseTypeId: this.filterList.souCourseTypeId,
            souCourseName: this.filterList.souCourseName,
            souCourseSchoolBegin: this.changeTime(this.createdAt), // 开课时间 // 格式：2023/12/08-2023/12/08
            teacherName: this.filterList.souTeacherName,
            page: this.page,
            limit: this.pageSize,
            financeOrderCount: financeOrderCount
        }

        for (const key in obj) {
            if (!obj[key] || obj[key].length === 0) {
                // if (!(key == 'teacherUserId' && obj[key] == 'null') && !(key == 'thesisUserId' && obj[key] == 'null') && !(key == 'helperUserId' && obj[key] == 'null')) {
                delete obj[key]
                // }
            }
        }
        try {
            const data: any = await getClasses(obj)
            this.tableData = data.classesList
            this.total = data.allNum
    
            this.$nextTick(() => {
                if (this.$refs.multipleTable) {
                    (this.$refs.multipleTable as HTMLFormElement).doLayout();
                    (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
                }
            });
            this.loading = false
        } catch {
            this.loading = false
        }
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(val: number) {
        this.pageSize = val
        this.getTableData()
    }

    // 取消调整表头
    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false
    }

    // 改变表头顺序
    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 22})
            this.$message.success('修改表头顺序成功')
            this.getClassClueHeader()
            this.tableHeadPopoverShow = false
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    getExportData() {
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        this.exportButtonDisabled = true

        const teacherUserId = this.teacherUserId == 'null' ? this.teacherUserId : this.filterList.teacherUserId
        const thesisUserId = this.thesisUserId == 'null' ? this.thesisUserId : this.filterList.thesisUserId
        const helperUserId = this.helperUserId == 'null' ? this.helperUserId : this.filterList.helperUserId
        const applyUserId = this.applyUserId == 'null' ? this.applyUserId : this.filterList.applyUserId
        const financeOrderCount = this.filter_amount + this.filter_price
        const obj = {
            name: this.filterList.name,
            code: this.filterList.classesCode,
            teacherUserId: teacherUserId,
            thesisUserId: thesisUserId,
            helperUserId: helperUserId,
            applyUserId: applyUserId,
            souCourseTypeId: this.filterList.souCourseTypeId,
            souCourseName: this.filterList.souCourseName,
            souCourseSchoolBegin: this.changeTime(this.createdAt), // 开课时间 // 格式：2023/12/08-2023/12/08
            teacherName: this.filterList.souTeacherName,
            financeOrderCount: financeOrderCount
        }
        exportClassesData(delNullProperty(obj)).then(() => {
            this.exportButtonDisabled = false
        }).catch(() => {
            this.exportButtonDisabled = false
        })

    }


    handleAddClass() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/AddClass', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }


    handleViewClass(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ClassInfo?id=' + row.id, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    handleEditClass(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ClassInfo?id=' + row.id+'&isShow=1', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    handleDelClass(row) {
        this.delId = row.id
        this.delClassDialogShow = true
    }

    delClassDialogConfirm() {
        delClasses({id: this.delId}).then(res => {
            this.delClassDialogShow = false
            this.$message.success('删除班级成功')
            this.getTableData()
        })
    }

    // 报名学员
    handleCilckCustumerList(row){
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/classStudent?id=' + row.id, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }


    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy/MM/dd', new Date(item)) + '-'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    // hideUser(){
    //     this.userList1 = []
    // }

    // userListFocus() {
    //     this.userList1 = this.userListNew
    // }

    changeHelperUsers(e){
        this.filterList.helperUserId = e.id
        this.helperUserId = ''
        this.pageChange(1)
    }
    changeThesisUsers(e){
        this.filterList.thesisUserId = e.id
        this.thesisUserId = ''
        this.pageChange(1)
    }
    changeTeacherUsers(e){
        this.filterList.teacherUserId = e.id
        this.teacherUserId = ''
        this.pageChange(1)
    }

    changeApplyUserId(e){
        this.filterList.applyUserId = e.id
        this.applyUserId = ''
        this.pageChange(1)
    }


    filterNullTeacher() {
        if (this.teacherUserId === '') {
            this.teacherUserId = 'null'
            this.filterList.teacherUserId = ''
        } else {
            this.teacherUserId = ''
        }
        this.pageChange(1)
    }

    filterNullThesisUsers() {
        if (this.thesisUserId === '') {
            this.thesisUserId = 'null'
            this.filterList.thesisUserId = ''
        } else {
            this.thesisUserId = ''
        }
        this.pageChange(1)
    }

    filterNullHelper() {
        if (this.helperUserId === '') {
            this.helperUserId = 'null'
            this.filterList.helperUserId = ''
        } else {
            this.helperUserId = ''
        }
        this.pageChange(1)
    }

    filterNullApplyUserId() {
        if (this.applyUserId === '') {
            this.applyUserId = 'null'
            this.filterList.applyUserId = ''
        } else {
            this.applyUserId = ''
        }
        this.pageChange(1)
    }

    openstatisticsData(){
        window.open(window.location.origin + this.$route.matched[0].path + '/ClassStaticData')
    }

}
